'use client'

import { useEffect, useRef, useState } from 'react'
import dayjs from 'dayjs'
import Select from "react-select"
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/20/solid'
import { message } from '../../../redux/actions/toastActions'
import { Postdata } from '../../../helpers/api.service'
import HttpService from '../../../helpers/httpServices'
import { useDispatch, useSelector } from 'react-redux'
import { isPermission, isRole } from '../../../redux/selectors/authSelector'

export default function WeekView({ currentDate }) {
  const container = useRef(null)
  const dispatch = useDispatch()

  const [currentWeekStart, setCurrentWeekStart] = useState(dayjs().startOf('week').add(1, 'day'))
  const [currentTime, setCurrentTime] = useState(dayjs())

  const [modalOpen, setModalOpen] = useState(false)
  const [showColorPicker, setShowColorPicker] = useState(false)
  const [editingIndex, setEditingIndex] = useState(null)
  const [editingDate, setEditingDate] = useState(null)

  const [formData, setFormData] = useState({
    id: null,
    title: '',
    date: '',
    start_time: '',
    end_time: '',
    place: '',
    members: [],
    notes: '',
    color: '#facc15',
    board_members: [],
  })

  const [events, setEvents] = useState({})
  const [member, setMember] = useState([])
  const [boardMember, setBoardMember] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [hoveredEvent, setHoveredEvent] = useState(null)
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 })
  const hideTimer = useRef(null)
  const [refresh, setRefresh] = useState(false)
  const permissions = useSelector(isPermission);
  const role = useSelector(isRole)
  console.log("permissions", permissions)
  const addPermission = role == "schooladmin" || permissions && permissions?.includes('edit_Education') || false;
  const deletePermission = role == "schooladmin" || permissions && permissions?.includes('delete_Education') || false;
  const showTooltip = (event, target) => {
    clearTimeout(hideTimer.current)
    const rect = target.getBoundingClientRect()
    const tooltipWidth = 260 // or whatever your tooltip width is
    const alignLeft = rect.left + tooltipWidth > window.innerWidth

    setTooltipPosition({
      x: rect.left,
      y: rect.top + window.scrollY,
      alignLeft
    })
    console.log("event>>>>>>>",event)
    setHoveredEvent(event)
  }

  const delayedHideTooltip = () => {
    hideTimer.current = setTimeout(() => setHoveredEvent(null), 200)
  }
  useEffect(() => {
    setCurrentWeekStart(currentDate.startOf('week').add(1, 'day'));
  }, [currentDate]);

  useEffect(() => {
    const interval = setInterval(() => setCurrentTime(dayjs()), 60000)
    return () => clearInterval(interval)
  }, [])

  const handleSaveEvent = () => {
    // const updatedEvents = { ...events }
    // const dateKey = formData.date
    // if (!updatedEvents[dateKey]) updatedEvents[dateKey] = []

    // if (editingIndex !== null && editingDate !== null) {
    //   updatedEvents[editingDate][editingIndex] = formData
    // } else {
    //   updatedEvents[dateKey].push(formData)
    // }
    // console.log("updatedEvents >>>>>>>>>>>>>", updatedEvents)
    // localStorage.setItem('calendarEvents', JSON.stringify(updatedEvents))
    // setEvents(updatedEvents)
    // setModalOpen(false)
    // setEditingIndex(null)
    // setEditingDate(null)

      // Validation to restrict reverse time
  if (
    dayjs(`${formData.date}T${formData.end_time}`).isBefore(
      dayjs(`${formData.date}T${formData.start_time}`)
    )
  ) {
    dispatch(message('End time should be greater than Start time'));
    return; // stop submitting
  }

    console.log("formData.date >>>>>>>>>>>", formData.date)
    const payload = {
      title: formData.title,
      place: formData.place,
      notes: formData.notes,
      date: formData.date,
      start_time: formData.start_time,
      end_time: formData.end_time,
      members: Array.isArray(formData.members) ? formData.members : [],
      board_members: Array.isArray(formData.board_members) ? formData.board_members : [],
      color: formData.color,
    };

    if (formData.id) {
      payload.id = formData.id
    }
    console.log("payload.id>>>>>>>>>>>", payload.id)

    setIsLoading(true)
    Postdata(HttpService.calendar_event_add, payload).then((response) => {
      if (response.status === 200) {

        const savedEvent = {
          ...response.data,
          _start: dayjs(`${dayjs(response.data.date).format("YYYY-MM-DD")}T${response.data.start_time}`),
          _end: dayjs(`${dayjs(response.data.date).format("YYYY-MM-DD")}T${response.data.end_time}`),
        };

        const dateKey = dayjs(savedEvent.date).format("YYYY-MM-DD");

        setEvents(prev => ({
          ...prev,
          [dateKey]: prev[dateKey] ? [...prev[dateKey], savedEvent] : [savedEvent],
        }));
        setRefresh(!refresh)
        setModalOpen(false);
        setEditingIndex(null);
        setEditingDate(null);

      } 
        dispatch(message(response.message));
      
    })
  }

  const handleDeleteEvent = (event) => {
    setIsLoading(true)
    Postdata(HttpService.calendar_event_delete, { id: event._id }).then((response) => {
      if (response.status === 200) {
        const dateKey = dayjs(event.date).format("YYYY-MM-DD");
        setEvents(prev => ({
          ...prev,
          [dateKey]: prev[dateKey].filter(e => e._id !== event._id),
        }));
        setRefresh(!refresh)
      } else {
        setIsLoading(false)
      }
      dispatch(message(response.message))
    })
  }


  const openEditModal = (event, date, index) => {
    setFormData({ ...event, id: event._id })
    setEditingIndex(index)
    setEditingDate(date)
    setModalOpen(true)
    setShowColorPicker(false)
  }

  const fetchBoardMember = () => {
    setIsLoading(true)
    Postdata(HttpService.board_management_list).then((response) => {
      if (response.status === 200) {
        setBoardMember(response.data.boards)
        setIsLoading(false)
      } else {
        setIsLoading(false)
        dispatch(message(response.message))
      }
    })
  }
  const fetchMembers = () => {
    setIsLoading(true)
    Postdata(HttpService.school_management_list).then((response) => {
      if (response.status === 200) {
        setMember(response.data.managers)
        setIsLoading(false)
      } else {
        setIsLoading(false)
        dispatch(message(response.message))
      }
    })
  }

  const fetchEvents = () => {
    setIsLoading(true)
    Postdata(HttpService.calendar_event_list).then((response) => {
      if (response.status === 200) {
        const grouped = {};
        response.data.forEach(event => {
          const dateKey = dayjs(event.date).format("YYYY-MM-DD");
          if (!grouped[dateKey]) grouped[dateKey] = [];
          grouped[dateKey].push({
            ...event,
            _start: dayjs(`${dateKey}T${event.start_time}`),
            _end: dayjs(`${dateKey}T${event.end_time}`),
          });
        });
        console.log("grouped>>>>>>>>>>", grouped)
        setEvents(grouped);
        setIsLoading(false)
      } else {
        setIsLoading(false)
        dispatch(message(response.message))
      }
    })
  }

  const handleBoardMemberChange = (selected) => {
    const selectedNames = selected ? selected.map((item) => item.value) : [];
    setFormData({ ...formData, board_members: selectedNames });
  }

  const handleMemberChange = (selected) => {
    const selectedNames = selected ? selected.map((item) => item.value) : [];
    setFormData({ ...formData, members: selectedNames });
  }

  useEffect(() => {
    fetchEvents()
  }, [refresh]);

  useEffect(() => {
    fetchMembers()
    fetchBoardMember()
    fetchEvents()
  }, [])


  const weekDays = Array.from({ length: 7 }).map((_, i) => currentWeekStart.add(i, 'day'))
  const hours = Array.from({ length: 24 }).map((_, i) => i)

  // Handle Event Clustering and Prevent Overflow
  const handleEventClustering = (dayEvents) => {
    const clusters = []
    const parsedEvents = dayEvents
      .map((e, i) => ({
        ...e,
        _index: i,
        _start: dayjs(`${e.date}T${e.start_time}`),
        _end: dayjs(`${e.date}T${e.end_time}`),
      }))
      .sort((a, b) => a._start.diff(b._start))

    parsedEvents.forEach((event) => {
      let placed = false
      for (const cluster of clusters) {
        if (
          cluster.some((e) => e._start.isBefore(event._end) && e._end.isAfter(event._start))
        ) {
          cluster.push(event)
          placed = true
          break
        }
      }
      if (!placed) clusters.push([event])
    })

    return clusters
  }

  return (
    <div className="flex h-screen flex-col">
      {/* Header */}
      <header className="flex items-center justify-between border-b border-gray-200 px-6 py-4">
        <h1 className="text-base font-semibold leading-6 text-gray-900">
          Week of {currentWeekStart.format('MMMM D, YYYY')}
        </h1>
        <div className="flex gap-2">
          <button onClick={() => setCurrentWeekStart(currentWeekStart.subtract(7, 'day'))}>
            <ChevronLeftIcon className="h-5 w-5 text-gray-600" />
          </button>
          <button onClick={() => setCurrentWeekStart(dayjs().startOf('week').add(1, 'day'))} className="text-sm">
            Today
          </button>
          <button onClick={() => setCurrentWeekStart(currentWeekStart.add(7, 'day'))}>
            <ChevronRightIcon className="h-5 w-5 text-gray-600" />
          </button>
        </div>
      </header>

      {/* Day Labels */}
      <div className="grid grid-cols-8 border-b border-gray-200 bg-gray-50 text-sm font-medium text-gray-700">
        <div className="border-r border-gray-200 p-2 text-right text-xs text-gray-500">Time</div>
        {weekDays.map((day, i) => (
          <div key={i} className="border-r border-gray-200 p-2 text-center">
            <div>{day.format('dddd')}</div>
            <div className="text-xs text-gray-500">{day.format('MMM D')}</div>
          </div>
        ))}
      </div>

      {/* Grid View */}
      <div ref={container} className="flex-auto overflow-auto">
        <div className="grid grid-cols-8 min-w-full">
          {/* Time Column */}
          <div className="bg-white border-r border-gray-200">
            {hours.map((hour) => (
              <div key={hour} className="h-20 border-b border-gray-100 text-xs text-right pr-2 pt-1 text-gray-500">
                {dayjs().hour(hour).format('h A')}
              </div>
            ))}
          </div>

          {/* Day Columns */}
          {weekDays.map((day, dayIdx) => {
            const dayKey = day.format('YYYY-MM-DD')
            const dayEvents = events[dayKey] || []
            const clusters = handleEventClustering(dayEvents)

            return (
              <div key={dayIdx} className="relative border-r border-gray-200 overflow-y-auto max-h-full">
                {hours.map((_, i) => (
                  <div
                    key={i}
                    className="h-20 border-b border-gray-100"
                    onClick={() => {
                      const clickedTime = day.hour(i).format('HH:mm')
                      setFormData({
                        title: '',
                        date: dayKey,
                        start_time: clickedTime,
                        end_time: clickedTime,
                        place: '',
                        members: [],
                        board_members: [],
                        notes: '',
                        color: '#facc15',
                      })
                      setModalOpen(true)
                      setEditingIndex(null)
                      setEditingDate(null)
                      setShowColorPicker(false)
                    }}
                  />
                ))}

                {/* Current Time Line */}
                {currentTime.isSame(day, 'day') && (
                  <div
                    className="absolute left-0 right-0 h-0.5 bg-red-500 z-10"
                    style={{ top: `${(currentTime.hour() + currentTime.minute() / 60) * 80}px` }}
                  />
                )}

                {/* Events with overlapping support */}
                {clusters.flatMap((cluster) => {
                  const total = cluster.length
                  return cluster.map((event, i) => {
                    const top = (event._start.hour() + event._start.minute() / 60) * 80
                    const height = (event._end.diff(event._start, 'minute') / 60) * 80
                    const widthPercent = 100 / total
                    const leftPercent = i * widthPercent

                    return (
                      <div
                        key={event.title + event.start_time + i}
                        className="absolute z-20 text-xs leading-5 text-white shadow cursor-pointer overflow-hidden rounded"
                        style={{
                          top: `${top}px`,
                          height: `${height}px`,
                          width: `calc(${widthPercent}% - 6px)`,
                          left: `calc(${leftPercent}% + 2px)`,
                          backgroundColor: event.color,
                          minWidth: '60px',
                          padding: '6px',
                          whiteSpace: 'normal',
                          wordBreak: 'break-word',
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'start',
                          alignItems: 'start',

                        }}
                        onPointerEnter={(e) => showTooltip(event, e.currentTarget)}
                        onPointerLeave={delayedHideTooltip}



                        onClick={() => openEditModal(event, event.date, event._index)}
                      >
                        <strong className="text-[11px] font-semibold leading-snug truncate w-full">
                          {event.title}
                        </strong>
                        <div className="text-[10px]">
                          {event._start.format('h:mm A')} – {event._end.format('h:mm A')}
                        </div>
                      </div>
                    )
                  })
                })}
              </div>
            )
          })}
        </div>
      </div>
      {hoveredEvent && (
        <div
          className="absolute z-50 bg-white rounded-md shadow-lg p-3 text-sm border w-64"
          style={{
            top: tooltipPosition.y + 10,
            left: tooltipPosition.alignLeft
              ? tooltipPosition.x - 270 // move left
              : tooltipPosition.x + 10 // move right
          }}
          onPointerEnter={() => clearTimeout(hideTimer.current)}
          onPointerLeave={delayedHideTooltip}
        >
          <h4 className="font-semibold text-gray-800 mb-1">{hoveredEvent.title}</h4>
          <p className="text-xs text-gray-600 mb-1">
            {hoveredEvent._start.format('dddd, MMM D')}<br />
            {hoveredEvent._start.format('h:mm A')} – {hoveredEvent._end.format('h:mm A')}
          </p>
          {hoveredEvent.place && <p><strong>Place:</strong> {hoveredEvent.place}</p>}
          {hoveredEvent.members && hoveredEvent.members.length > 0 && (
            <p>
              <strong>Members:</strong>{" "}
              {member
                .filter(m => hoveredEvent.members.includes(m._id))
                .map(m => m.name)
                .join(", ")}
            </p>
          )}
          {hoveredEvent.board_members && hoveredEvent.board_members.length > 0 && (
            <p>
              <strong>Board Members:</strong>{" "}
              {boardMember
                .filter(m => hoveredEvent.board_members.includes(m._id))
                .map(m => m.name)
                .join(", ")}
            </p>
          )}
          {hoveredEvent.notes && <p><strong>Notes:</strong> {hoveredEvent.notes}</p>}
          <div className="mt-3 flex gap-2 justify-end">
            {addPermission && <button
              className="text-xs text-indigo-600 hover:underline"
              onClick={() => {
                openEditModal(hoveredEvent, hoveredEvent.date, hoveredEvent._index)
                setHoveredEvent(null)
              }}
            >
              Edit
            </button>}
            {deletePermission && <button
            onClick={()=>handleDeleteEvent(hoveredEvent)}
              className="text-xs text-red-600 hover:underline"
            >
              Delete
            </button>}
          </div>
        </div>
      )}

      {/* Event Modal */}
      {modalOpen && addPermission && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-25">
          <div className="bg-white rounded-2xl shadow-xl p-6 w-full max-w-md space-y-4">
            <div className="flex justify-between items-center">
              {/* <input
                type="text"
                placeholder="Event Title"
                className="text-lg font-semibold w-full outline-none"
                value={formData.title}
                onChange={(e) => setFormData({ ...formData, title: e.target.value })}
              /> */}
              <span className="text-lg font-semibold w-full outline-none">Add Event</span>
              <div className="relative ml-3">
                <button
                  className="w-10 h-6 flex items-center justify-center rounded-full border bg-white shadow"
                  onClick={() => setShowColorPicker(!showColorPicker)}
                >
                  <span className="w-3 h-3 rounded-full" style={{ backgroundColor: formData.color }} />
                   <span className="text-md p-1">▼</span>
                </button>
                {showColorPicker && (
                  <div className="absolute right-0 mt-2 bg-white p-2 rounded shadow grid gap-2 z-10">
                    {['#f87171', '#facc15', '#4ade80', '#60a5fa', '#a78bfa', '#f472b6'].map((color) => (
                      <button
                        key={color}
                        onClick={() => {
                          setFormData({ ...formData, color })
                          setShowColorPicker(false)
                        }}
                        className="w-5 h-5 rounded-full"
                        style={{ backgroundColor: color }}
                      />
                    ))}
                    
                  </div>
                )}
              </div>
            </div>
                 <input
                type="text"
                placeholder="Event Title"
                className="w-full border rounded px-3 py-2 outline-none"
                value={formData.title}
                onChange={(e) => setFormData({ ...formData, title: e.target.value })}
              />
            <div className="grid grid-cols-2 gap-3">
              <input
              type="text"
              placeholder="Place"
              className="w-full border rounded px-3 py-2 outline-none"
              value={formData.place}
              onChange={(e) => setFormData({ ...formData, place: e.target.value })}
            />
             
              <input
                type="time"
                className="w-full border rounded px-3 py-2 outline-none"
                value={formData.start_time}
                onChange={(e) => setFormData({ ...formData, start_time: e.target.value })}
              />
               <input
                placeholder='Select Date'
                type="date"
                className="w-full border rounded px-3 py-2 outline-none"
                value={formData.date}
                onChange={(e) => setFormData({ ...formData, date: e.target.value })}
              />
              <input
                type="time"
                className="w-full border rounded px-3 py-2 outline-none"
                value={formData.end_time}
                min={formData.start_time}
                onChange={(e) => setFormData({ ...formData, end_time: e.target.value })}
              />
            </div>

            
            {/* <input
              type="text"
              placeholder="Members"
              className="w-full border rounded px-3 py-2 outline-none"
              value={formData.members}
              onChange={(e) => setFormData({ ...formData, members: e.target.value })}
            /> */}
            <Select
              isMulti
              name='members'
              placeholder="School Members"
              options={member.map((m) => ({ value: m._id, label: m.name }))}
              value={formData.members && formData.members.map((id) => ({
                value: id,
                label: member.find((m) => m._id === id).name
              }))
              }
              onChange={handleMemberChange}
            />
            <Select
              isMulti
              name='board members'
              placeholder="Board Members"
              options={boardMember.map((m) => ({ value: m._id, label: m.name }))}
              value={formData.board_members && formData.board_members.map((id) => ({
                value: id,
                label: boardMember.find((m) => m._id === id).name
              }))
              }
              onChange={handleBoardMemberChange}
            />
            <textarea
              placeholder="Notes"
              className="w-full border rounded px-3 py-2 outline-none"
              rows={2}
              value={formData.notes}
              onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
            />

            <div className="flex justify-end space-x-2 pt-2">
              <button
                onClick={() => setModalOpen(false)}
                className="px-4 py-2 rounded bg-gray-100 hover:bg-gray-200"
              >
                Cancel
              </button>
              <button
                onClick={handleSaveEvent}
                className="px-4 py-2 rounded bg-indigo-600 text-white hover:bg-indigo-700"
              >
                {editingIndex !== null ? 'Update' : 'Save'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
